import { Component, Input } from '@angular/core';
import { IaService, RegistroIA } from 'src/app/services/ia/ia.service';
import {
  ETIQUETA_TIPO, etiquetaFila, motivoLegible, partesDelMotivo, celda, decimalesDeColumna, errorDeIA, fechaHora, ms, nf, nombreProveedor, tituloAgente, usd,
} from 'src/app/services/ia/ia-formato';

/**
 * EL DETALLE DE UNA LÍNEA DE LA BITÁCORA — se abre DEBAJO de su fila.
 *
 * Se usa en la Bitácora y en «Últimas preguntas» de la ficha del comercio, con
 * el mismo marcado: la pregunta, lo que se contestó, la consulta que se armó y,
 * al costado, los datos de la llamada.
 *
 * 🔴 AQUÍ, Y SÓLO AQUÍ, APARECEN LOS TOKENS (regla del piloto). En las columnas
 * va el costo en dólares, que es lo que se lee; los tokens sirven cuando alguien
 * ya está averiguando por qué UNA llamada salió cara.
 *
 * 📍 El pulgar va a `POST /admin/decisiones/:id/acuerdo`. Sólo si la fila tiene
 * `_id`: sin él no hay a qué atarle la opinión.
 */
@Component({
  selector: 'app-ia-registro',
  templateUrl: './ia-registro.component.html',
  styleUrls: ['./ia-registro.component.css']
})
export class IaRegistroComponent {
  @Input() registro!: RegistroIA;

  opinando = false;
  errorOpinion: string | null = null;

  readonly usd = usd;
  readonly ms = ms;
  readonly nf = nf;
  readonly fechaHora = fechaHora;
  readonly tituloAgente = tituloAgente;
  readonly nombreProveedor = nombreProveedor;
  readonly ETIQUETA_TIPO = ETIQUETA_TIPO;
  readonly etiquetaFila = etiquetaFila;
  readonly motivoLegible = motivoLegible;
  readonly partesDelMotivo = partesDelMotivo;

  constructor(private _ia: IaService) { }

  /** La respuesta puede venir como texto o como la `RespuestaAsistente` entera. */
  get textoRespuesta(): string | null {
    const r: any = this.registro?.respuesta;
    if (r === null || r === undefined || r === '') return null;
    if (typeof r === 'string') return r;
    if (typeof r === 'object' && typeof r.respuesta === 'string') return r.respuesta;
    return null;
  }

  get tablaRespuesta(): any {
    const r: any = this.registro?.respuesta;
    return r && typeof r === 'object' && r.tabla && Array.isArray(r.tabla.columnas) ? r.tabla : null;
  }

  get respuestaCruda(): string | null {
    const r: any = this.registro?.respuesta;
    if (r && typeof r === 'object' && typeof r.respuesta !== 'string') return JSON.stringify(r, null, 2);
    return null;
  }

  get peticion(): string | null {
    const p = this.registro?.peticion;
    if (p === null || p === undefined || p === '') return null;
    return typeof p === 'string' ? p : JSON.stringify(p, null, 2);
  }

  opinar = async (deAcuerdo: boolean): Promise<void> => {
    const id = this.registro?._id;
    if (!id || this.opinando) return;
    this.opinando = true;
    this.errorOpinion = null;
    try {
      await this._ia.opinarDecision(id, deAcuerdo);
      this.registro.humanoDeAcuerdo = deAcuerdo;
      this.registro.humanoEl = new Date().toISOString();
    } catch (e: any) {
      this.errorOpinion = errorDeIA(e, true);
    } finally {
      this.opinando = false;
    }
  };

  esNumero = (v: any): boolean => typeof v === 'number';

  formato = (i: number): string => {
    const t = this.tablaRespuesta;
    if (!t) return '1.0-0';
    return decimalesDeColumna(t.columnas[i], (t.filas || []).map((f: any[]) => f[i]));
  };

  readonly celda = celda;

  columnaNumerica = (i: number): boolean => {
    const filas = this.tablaRespuesta?.filas || [];
    return filas.length > 0 && filas.every((f: any[]) => f[i] === null || typeof f[i] === 'number');
  };
}
